import { useQuery } from "react-query";
import MerchantService from "services/MerchantService";

const GET_MERCHANT = "GET_MERCHANT";
const GET_PUBLIC_MERCHANT = "GET_PUBLIC_MERCHANT";

const useGetMerchant = (payload, enabled = true) => {
  return useQuery({
    queryKey: [GET_MERCHANT, payload],
    queryFn: () => MerchantService.getMerchant(payload),
    enabled: enabled,
  });
};

const useGetPublicMerchant = (payload, enabled) => {
  return useQuery({
    queryKey: [GET_PUBLIC_MERCHANT, payload],
    queryFn: () => MerchantService.getPublicMerchant(payload),
    enabled: !!enabled,
  });
};

export { useGetMerchant, useGetPublicMerchant };
